import React,{ useState,useEffect} from 'react'
import {  Empty, Menu, Pagination, Spin } from 'antd'
import Button from '@mui/material/Button';
import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft } from "react-icons/fa";
import {useDispatch} from 'react-redux'
import CustomeHeader from '../../../components/Admin/Common/CustomeHeader'
import SimpleTable from '../Common/SimpleTable'

import {  TableTitle, TableTop } from '../../../StyledComponents/CreateKeyAccountManager'
import { MainContainer } from '../../../StyledComponents/Dashboard'
// import { IconImg } from '../StyledComponents/Header'
import { ContentContainer, TableFilter } from '../../../StyledComponents/RateManagement'

import { FilterSection, SpinContainer } from '../../../StyledComponents/Queries'

import ViewButton from '../../../components/Admin/Common/ViewButton'

import SearchBox from '../../../components/Admin/Common/SearchBox'
import AirlineproductForm from './AirlineproductForm';
import { render } from '@testing-library/react';
import { Air } from '@mui/icons-material';
import {getAirlineProduct,getAirlineProductbyId} from '../../../store/Admin/Airlineproduct/Airlineproductslice'
import { set } from 'react-hook-form';
const AirlineproductMain = () => {
    const dispatch=useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [tab,setTab]=useState(0);
    const [data, setData] = useState([]);
    const [databyid,setDatabyid]=useState([])
    const [search,setSearch]=useState("");
    // const [errors, setErrors] = useState({ selectedCarr: "", numCarrCode: "" });
    useEffect(() => {
        dispatch(getAirlineProduct()).then((res) => {
            console.log("login res => ", res?.payload?.data);
            setData(res?.payload?.data);
        }).catch(err => {
            console.error(err);
        })
    },[tab])
    // const data = [
    //     { id: 1, airline: "Emirates", product: "First Class" },
    //     { id: 2, airline: "Qatar Airways", product: "Business Class" },
    //     { id: 3, airline: "Singapore Airlines", product: "Economy Plus" },
    //     { id: 4, airline: "Lufthansa", product: "Premium Economy" },
    //     { id: 5, airline: "British Airways", product: "Economy" },
    //     { id: 6, airline: "Delta", product: "Business Class" },
    //     { id: 7, airline: "United", product: "First Class" },
    //     { id: 8, airline: "Air France", product: "Economy Plus" },
    //     { id: 9, airline: "Turkish Airlines", product: "Premium Economy" },
    //     { id: 10, airline: "Etihad", product: "Business Class" },
    //     { id: 11, airline: "KLM", product: "Economy" },
    //     { id: 12, airline: "ANA", product: "First Class" },
    //   ];
      
        const handleView = (record) => {
            dispatch(getAirlineProductbyId(record?.airline_product_id?._id)).then(res =>{console.log(res,"res7890")

              if(res?.payload?.statusCode === 200){
                setDatabyid(res?.payload?.data);
                setTab(2);
              }
            }).catch(err =>{console.log(err,"err")});
         console.log(record,"hiapm");
        };
      const columns = [
        {
            title: "Sr. No",
            key: "slno",
            render: (text, record, index) => (currentPage - 1) * pageSize + index + 1, // Adjusting based on page number
          },
        {
          title: "Airline",
          dataIndex: "airline",
          key: "airline",
          render: (text, record) => {console.log(record,"record");return <div>{record?.airline_product_id?.carr_name}</div>},
        },
        {
            title: "Product",
            dataIndex: "product",
            key: "product",
            render: (text, record) => (
              <div>
                {record?.product_type?.map((item, index) => (
                  <div key={index}>{item?.product_type},</div>
                ))}
              </div>
            ),
          },
        {
          title: "Action",
          key: "action",

          render: (record) => (
            <ViewButton handleClick={() => handleView(record)} data={record} />
          ),
        },
      ];
      const handleadd =()=>{
        setTab(1)
      }
      const handleinputchange=(e)=>{
 console.log(e.target.value)
 setSearch(e.target.value);

      }
      const filtereddata = data?.filter((item) =>
        item?.airline_product_id?.carr_name?.toLowerCase().includes(search.toLowerCase())
      );
  
  console.log("filtereddata",filtereddata)
      return (
    <>
      <section className="airlineProductMain">
        <MainContainer>
          <CustomeHeader title="Airline Product"  />
          {tab===0&&(
            <ContentContainer>
                <TableTop>
                    <TableTitle>Manage airline product</TableTitle>
                      <FilterSection className='filter'>
                      {/* <SearchBox  /> */}
                    <input className="border-2 rounded-md p-2 border-solid" placeholder='search....' type='text' onChange={handleinputchange}></input>
                    <Button className="btn btn_54" variant="outlined" onClick={handleadd}><span className='m-2' ><FaPlus /></span>Add Product</Button>
                    
                      </FilterSection>

                </TableTop>
                <div className="tableResponsiveASAP">
                  <SimpleTable  columns={columns}
                    data={filtereddata}
                    rowKey="id"
                    // scroll={true}
                    showScroll={true}
                    currentPage={currentPage}
                    pageSize={pageSize} />
                  <div className='paginationCustom'>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={filtereddata.length}
                        onChange={(page, size) => {
                          setCurrentPage(page);
                          setPageSize(size);
                        }}
                      //   showSizeChanger
                      />
                  </div>
              </div>

            </ContentContainer>)}
            {
                tab===1&&(

                <ContentContainer>
                <TableTop className='flex items-start justify-start'>
                    <Button onClick={()=>setTab(0)}><FaArrowLeft />
                    </Button>
                  { tab===0&& (<TableTitle>Manage airline product</TableTitle>)}
                  { tab===1&& (<TableTitle>Create airline product</TableTitle>)}
                  { tab===2&& (<TableTitle>Edit airline product</TableTitle>)}
                </TableTop>
              
                <AirlineproductForm setTab={setTab} tab={tab} />
                

                </ContentContainer>
                )
                // <AirlineproductForm setTab={setTab} />
            }
            {
                tab===2&&(

                <ContentContainer>
                <TableTop className='flex items-start justify-start'>
                    <Button onClick={()=>setTab(0)}><FaArrowLeft />
                    </Button>
                    { tab===0&& (<TableTitle>Manage airline product</TableTitle>)}
                  { tab===1&& (<TableTitle>Create airline product</TableTitle>)}
                  { tab===2&& (<TableTitle>Edit airline product</TableTitle>)}
                </TableTop>
              
                <AirlineproductForm setTab={setTab} tab={tab} props={databyid} />
                

                </ContentContainer>
                )
                // <AirlineproductForm setTab={setTab} />
            }
        </MainContainer>
      </section>
    </>
  )
}

export default AirlineproductMain